














































































































import Vue from "vue"
import {StoryTask, StoryUtils, TaskEditAction, TaskEditType} from '../lib/story-utils';
import TaskEditor from "./TaskEditor.vue"
import ConfirmationBox from './ConfirmationBox.vue'

export default Vue.extend({
  props: ['info'],

  data() {
    return {
      changed: false,
      storyInfo: StoryUtils.copyStoryInfo(this.info),
      taskEditor: {show: false, title: '', action: {} as TaskEditAction},
      confirmation: {
        show: false,
        title: '',
        message: ''
      }
    }
  },

  computed: {
    fatColumnClass(): string {
      let eleNum = 2 + this.storyInfo.transforms.length
      let each = Math.ceil(12 / eleNum)
      return `is-${each}`
    },
    thinColumnClass(): string {
      let eleNum = 2 + this.storyInfo.transforms.length
      let each = Math.floor(12 / eleNum)
      return `is-${each}`
    }
  },

  components: {
    TaskEditor,
    ConfirmationBox
  },

  filters: {
    jsonPretty: StoryUtils.jsonPretty
  },

  methods: {
    onAddTask(title: string, category: string) {
      this.taskEditor = {
        ...this.taskEditor, ...{
          show: true,
          title: title,
          action: new TaskEditAction(TaskEditType.ADD, category, {} as StoryTask)
        }
      }
    },

    onEditTask(title: string, category: string, task: StoryTask) {
      this.taskEditor = {
        ...this.taskEditor, ...{
          show: true,
          title: title,
          action: new TaskEditAction(TaskEditType.EDIT, category, task)
        }
      }
    },

    onRemoveTask(category: string, index?: number) {
      if (!confirm(`Are you sure delete this ${category}?`)) {
        return;
      }

      switch (category) {
        case 'transform':
          if (index != undefined && this.storyInfo.transforms[index]) {
            console.log(this.storyInfo.transforms)
            this.storyInfo.transforms.splice(index, 1)
            console.log(this.storyInfo.transforms)
            this.changed = true
          }
          break;

        case 'fallback':
          this.storyInfo.fallback = undefined
          this.changed = true
          break;
      }
    },

    onTaskEditorClose() {
      this.taskEditor = {...this.taskEditor, ...{show: false}}
    },

    onTaskEditorSave(action: TaskEditAction, newTask: StoryTask) {

      if (action.type == TaskEditType.ADD) {
        switch (action.taskCategory) {
          case 'transform':
            this.storyInfo.transforms.push(newTask)
            break;
          case 'fallback':
            this.storyInfo.fallback = newTask
            break;
        }
      }
      else {
        if (action.task) {
          action.task.type = newTask.type
          action.task.settings = newTask.settings
        }
      }

      this.changed = true
      console.log('updated storyInfo: ', JSON.stringify(this.storyInfo))

      this.onTaskEditorClose()

    },

    onResetChanges() {
      if (!confirm('Are you sure to reset everything?')) {
        return;
      }
      this.storyInfo = StoryUtils.copyStoryInfo(this.info)
      this.changed = false
    },

    onSaveStory() {
      let message = StoryUtils.jsonPretty(JSON.stringify(this.storyInfo));
      this.confirmation = {
        ...this.confirmation, ...{
          show: true,
          title: 'Are you sure to save the Story?',
          message: `<article class="content"><pre>${message}</pre></article>`
        }
      }
    },

    onConfirm() {
      this.$emit('save', this.storyInfo)
      this.changed = false
      this.onNotConfirm()
    },

    onNotConfirm() {
      this.confirmation = {...this.confirmation, ...{show: false}}
    }
  }
})




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StoryGraph.vue